import { render, staticRenderFns } from "./xianYuOrder.vue?vue&type=template&id=2d71db55&scoped=true"
import script from "./xianYuOrder.vue?vue&type=script&lang=js"
export * from "./xianYuOrder.vue?vue&type=script&lang=js"
import style0 from "./xianYuOrder.vue?vue&type=style&index=0&id=2d71db55&prod&scoped=true&lang=css"
import style1 from "./xianYuOrder.vue?vue&type=style&index=1&id=2d71db55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71db55",
  null
  
)

export default component.exports